export default __webpack_public_path__ + "static/media/coil.0881d889.jpg";